module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "video-small-thumbnail-hovered.4ea15e5d.png";